import { useMemo } from 'react';
import { useEventStore } from '@/state/stores/use-event-store';
import type { SessionDto } from '@/types/dtos/sessions/session.dto';

export type SessionWithSlotDuration = SessionDto & { slotDurationMinutes: number };

// eventSessions are populated while flow.slots[].session isnt,
// so we iterate through slots and attach populated top level objects
export default function useSlotSessions(): SessionWithSlotDuration[] {
  const eventFlows = useEventStore((s) => s.eventFlows);
  const sessions = useEventStore((s) => s.eventSessions);

  return useMemo(() => {
    if (!eventFlows || !sessions) {
      return [];
    }

    const sessionsHashMap = new Map<string, SessionDto>();
    sessions.forEach((session) => {
      sessionsHashMap.set(session.id, session);
    });

    const slotSessions: SessionWithSlotDuration[] = [];

    eventFlows.forEach((flow) => {
      if (flow.slots) {
        const sessionSlots = flow.slots.filter((slot) => slot.contentType === 'Session');

        sessionSlots.forEach((sessionSlot) => {
          if (sessionSlot.content && sessionSlot.content.id) {
            const populatedSession = sessionsHashMap.get(sessionSlot.content.id);
            if (populatedSession) {
              slotSessions.push({
                ...populatedSession,
                slotDurationMinutes: sessionSlot?.computedDurationMinutes ?? sessionSlot?.plannedDurationMinutes ?? 0,
              });
            }
          }
        });
      }
    });

    return slotSessions;
  }, [eventFlows, sessions]);
}
